<ng-container *ngIf="disableDeviceMenuItem; else overviewTemplate">
  <div class="row">
    <div class="col">
      <div class="jumbotron" style="padding-top: 0px; padding-bottom: 0px;">
        <h1 class="display-4">{{'event.details.usersAndAccessDatas' | translate}}</h1>
        <p class="lead">
          {{'event.details.missingHardwareDesc' | translate}}
        </p>
        <hr class="my-4">
      </div>
    </div>
  </div>
</ng-container>
<ng-template #overviewTemplate>
  <div class="row">
    <div class="col">
      <div class="jumbotron" style="padding-top: 0px; padding-bottom: 0px;">
        <h1 class="display-4" style="font-size: 30px">{{'event.details.usersAndAccessDatas' | translate}}</h1>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <div class="card" *ngIf="event.deviceUsers.length > 0">
        <div class="card-header" style="position: relative;">
          {{'event.details.deviceUsers' | translate}}
          <div class="scroll-info">
            &rArr;&nbsp;&nbsp;Scroll
          </div>
        </div>
        <div class="card-body" style="width: 100%; overflow-y: scroll;">
          <div class="table-responsive" style="width:100%;">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th>{{'event.details.rule' | translate}}</th>
                  <th #nameAnchor (mouseover)="togglePopup(nameAnchor, namePopup, true)" (mouseout)="togglePopup(nameAnchor, namePopup, false)" style="cursor: pointer" class="ignore-click-listener">
                    <span style="text-decoration: underline; display: flex" class="ignore-click-listener">{{'event.details.name' | translate}}
                      <div class="infobutton">
                        <i class="fa fa-info" style="color: white"></i>
                      </div>
                    </span>
                  </th>
                  <th #showPaymentsAnchor (mouseover)="togglePopup(showPaymentsAnchor, showPaymentsPopup, true)" (mouseout)="togglePopup(showPaymentsAnchor, showPaymentsPopup, false)" style="cursor: pointer" class="ignore-click-listener">
                    <span style="text-decoration: underline; display: flex" class="ignore-click-listener">{{ 'event.details.showPayments' | translate }}
                      <div class="infobutton">
                        <i class="fa fa-info" style="color: white"> </i>
                      </div>
                    </span>
                  </th>
                  <th #showSalesAnchor (mouseover)="togglePopup(showSalesAnchor, showSalesPopup, true)" (mouseout)="togglePopup(showSalesAnchor, showSalesPopup, false)" style="cursor: pointer" class="ignore-click-listener">
                    <span style="text-decoration: underline; display: flex" class="ignore-click-listener">{{ 'event.details.showSales' | translate }}
                      <div class="infobutton">
                        <i class="fa fa-info" style="color: white"> </i>
                      </div>
                    </span>
                  </th>
                  <th #doublePrintAnchor (mouseover)="togglePopup(doublePrintAnchor, doublePrintPopup, true)" (mouseout)="togglePopup(doublePrintAnchor, doublePrintPopup, false)" style="cursor: pointer" class="ignore-click-listener">
                    <span style="text-decoration: underline; display: flex" class="ignore-click-listener">{{ 'event.details.enableDoublePrint' | translate }}
                      <div class="infobutton">
                        <i class="fa fa-info" style="color: white"> </i>
                      </div>
                    </span>
                  </th>
                  <th #paidWithoutPrintAnchor (mouseover)="togglePopup(paidWithoutPrintAnchor, paidWithoutPrintPopup, true)" (mouseout)="togglePopup(paidWithoutPrintAnchor, paidWithoutPrintPopup, false)" style="cursor: pointer" class="ignore-click-listener">
                    <span style="text-decoration: underline; display: flex" class="ignore-click-listener">{{ 'event.details.paidWithoutPrint' | translate }}
                      <div class="infobutton">
                        <i class="fa fa-info" style="color: white"> </i>
                      </div>
                    </span>
                  </th>
                  <th #enableSumUpAnchor (mouseover)="togglePopup(enableSumUpAnchor, enableSumUpPopup, true)" (mouseout)="togglePopup(enableSumUpAnchor, enableSumUpPopup, false)" style="cursor: pointer" class="ignore-click-listener" *ngIf="event.hasSumUp">
                    <span style="text-decoration: underline; display: flex" class="ignore-click-listener">{{ 'event.details.enableSumup' | translate }}
                      <div class="infobutton">
                        <i class="fa fa-info" style="color: white"> </i>
                      </div>
                    </span>
                  </th>
                  <th #enableVivaWalletAnchor (mouseover)="togglePopup(enableVivaWalletAnchor, enableVivaWalletPopup, true)" (mouseout)="togglePopup(enableVivaWalletAnchor, enableVivaWalletPopup, false)" style="cursor: pointer" class="ignore-click-listener" *ngIf="event.hasVivaWallet">
                    <span style="text-decoration: underline; display: flex" class="ignore-click-listener">{{ 'event.details.enableVivaWallet' | translate }}
                      <div class="infobutton">
                        <i class="fa fa-info" style="color: white"> </i>
                      </div>
                    </span>
                  </th>
                  <th #enableWorldLineAnchor (mouseover)="togglePopup(enableWorldLineAnchor, enableWorldLinePopup, true)" (mouseout)="togglePopup(enableWorldLineAnchor, enableWorldLinePopup, false)" style="cursor: pointer" class="ignore-click-listener" *ngIf="event.hasWorldLine">
                    <span style="text-decoration: underline; display: flex" class="ignore-click-listener">{{ 'event.details.enableWorldLine' | translate }}
                      <div class="infobutton">
                        <i class="fa fa-info" style="color: white"> </i>
                      </div>
                    </span>
                  </th>
                  <th *ngIf="fiscalPrinterLicenses.qtySoftware > 0 || fiscalPrinterLicenses.qtyHardware > 0"
                      #enableFiscalPrinterAnchor (mouseover)="togglePopup(enableFiscalPrinterAnchor, enableFiscalPrinterPopup, true)" (mouseout)="togglePopup(enableFiscalPrinterAnchor, enableFiscalPrinterPopup, false)" style="cursor: pointer" class="ignore-click-listener"
                  >
                    <span style="text-decoration: underline; display: flex" class="ignore-click-listener">{{ 'event.details.enableFiscalPrinter' | translate }}
                      <div class="infobutton">
                        <i class="fa fa-info" style="color: white"> </i>
                      </div>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let deviceUser of event.deviceUsers">
                  <td>{{'event.details.' + deviceUser.deviceUserType.name | translate}}</td>
                  <td><kendo-textbox
                    selectOnFocus="true"
                    type="text"
                    [attr.id]="'input-username-' + deviceUser.id"
                    [(ngModel)]="deviceUser.name"
                    placeholder="{{deviceUser.name}}">
                  </kendo-textbox>
                  </td>
                  <td><input type="checkbox" [(ngModel)]="deviceUser.enablePaymentScreen" [attr.id]="'checkbox-payment-' + deviceUser.id" [disabled]="hasFiscalPrinter"></td>
                  <td><input type="checkbox" [(ngModel)]="deviceUser.showSales" [attr.id]="'checkbox-sales-' + deviceUser.id"></td>
                  <td><input type="checkbox" [(ngModel)]="deviceUser.enableDoublePrint" [attr.id]="'checkbox-double-print-' + deviceUser.id" [disabled]="eventWithoutPrinter"></td>
                  <td><input type="checkbox" [(ngModel)]="deviceUser.paidWithoutPrint" [attr.id]="'checkbox-paidWithoutPrint-' + deviceUser.id" [disabled]="eventWithoutPrinter"></td>
                  <td *ngIf="event.hasSumUp">
                    <input (change)="updateSumUpCount($event)" *ngIf="(deviceUser.deviceUserType.id === 1 || deviceUser.deviceUserType.id === 2) && (deviceUser.enableSumUp || sumUpCount < sumUpCost?.quantity); else disabledCheckbox"
                      type="checkbox" [(ngModel)]="deviceUser.enableSumUp" [attr.id]="'checkbox-sumup-' + deviceUser.id">
                  </td>
                  <td *ngIf="event.hasVivaWallet">
                    <input (change)="updateVivaWalletCount($event)" *ngIf="(deviceUser.deviceUserType.id === 1 || deviceUser.deviceUserType.id === 2) && (deviceUser.enableVivaWallet || vivaWalletCount < vivaWalletCost?.quantity); else disabledCheckbox"
                      type="checkbox" [(ngModel)]="deviceUser.enableVivaWallet" [attr.id]="'checkbox-vivawallet-' + deviceUser.id">
                  </td>
                  <td *ngIf="event.hasWorldLine">
                    <input (change)="updateWorldLineCount($event)" *ngIf="(deviceUser.deviceUserType.id === 1 || deviceUser.deviceUserType.id === 2) && (deviceUser.enableWorldLine || worldLineCount < worldLineCost?.quantity); else disabledCheckbox"
                      type="checkbox" [(ngModel)]="deviceUser.enableWorldLine" [attr.id]="'checkbox-worldline-' + deviceUser.id">
                  </td>
                  <td *ngIf="fiscalPrinterLicenses.qtySoftware > 0 || fiscalPrinterLicenses.qtyHardware > 0">
                    <input *ngIf="deviceUser.deviceUserType.id === 1 || deviceUser.deviceUserType.id === 2; else disabledCheckbox"
                      type="checkbox" [(ngModel)]="deviceUser.hasFiscalPrinter" [attr.id]="'checkbox-hasFiscalPrinter-' + deviceUser.id">
                  </td>
                  <ng-template #disabledCheckbox><input type="checkbox" [disabled]="true"/></ng-template>
                </tr>
              </tbody>
            </table>
            <div *ngIf="!eventWithoutPrinter" style="display: flex; padding-left: 15px; gap: 10px; font-size: 16px;">
              <div style="font-weight: bold; margin-right: 10px">{{'event.details.printSize' | translate}}:</div>
              <div>{{'event.details.printSizeSmall' | translate}}</div>
              <input style="margin-right: 10px" type="radio" name="printSize" id="printSizeSmall" [value]="0" (change)="updateEvent()" [(ngModel)]="event.deviceReceiptSize" [attr.id]="'checkbox-printsize-small-' + event.id">
              <div>{{'event.details.printSizeLarge' | translate}}</div>
              <input type="radio" name="printSize" id="printSizeLarge" [value]="1" (change)="updateEvent()" [(ngModel)]="event.deviceReceiptSize" [attr.id]="'checkbox-printsize-large-' + event.id">
            </div>
            <hr />
            <h4 style="font-weight: bold">{{'event.details.qrCodesTitle' | translate}}</h4>
            <h5 style="margin-bottom: 10px">{{'event.details.qrCodesDescription' | translate}}</h5>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 30px; margin-bottom: 20px; margin-left: 20px; justify-content: center">
              <div *ngFor="let deviceUser of event.deviceUsers">
                <div style="border: 1px solid">
                  <div style="font-size: medium; text-align: center;">{{deviceUser.name}}</div>
                  <kendo-qrcode style="display: flex; justify-content: center; margin: 10px" value="famulusapp://rudi.com/du?a={{deviceUser.username}}&b={{deviceUser.pinCode}}" [style.width.px]="140"></kendo-qrcode>
                </div>
              </div>
            </div>
            <ng-template #namePopup>
              <div class="device-popup ignore-click-listener" style="border:#5bc0de 5px solid">{{'event.details.name_description' | translate}}</div>
            </ng-template>
            <ng-template #showPaymentsPopup>
              <div class="device-popup ignore-click-listener" style="border:#5bc0de 5px solid">{{'event.details.showPayments_description' | translate}}</div>
            </ng-template>
            <ng-template #showSalesPopup>
              <div class="device-popup ignore-click-listener" style="border:#5bc0de 5px solid">{{'event.details.showSales_description' | translate}}</div>
            </ng-template>
            <ng-template #doublePrintPopup>
              <div class="device-popup ignore-click-listener" style="border:#5bc0de 5px solid">{{'event.details.enableDoublePrint_description' | translate}}</div>
            </ng-template>
            <ng-template #paidWithoutPrintPopup>
              <div class="device-popup ignore-click-listener" style="border:#5bc0de 5px solid">{{'event.details.paidWithoutPrint_description' | translate}}</div>
            </ng-template>
            <ng-template #enableSumUpPopup>
              <div class="device-popup ignore-click-listener" style="border:#5bc0de 5px solid">{{ sumUpDescription }}</div>
            </ng-template>
            <ng-template #enableVivaWalletPopup>
              <div class="device-popup ignore-click-listener" style="border:#5bc0de 5px solid">{{ vivaWalletDescription }}</div>
            </ng-template>
            <ng-template #enableWorldLinePopup>
              <div class="device-popup ignore-click-listener" style="border: #5bc0de 5px solid"> {{ worldLineDescription }} </div>
            </ng-template>
            <ng-template #enableFiscalPrinterPopup>
              <div class="device-popup ignore-click-listener" style="border:#5bc0de 5px solid">{{ fiscalPrinterDescription }}</div>
            </ng-template>
            <hr/>
            <div style="display: flex; gap: 50px;">
              <div *ngIf="false" style="width: 50%;">
                <h6 class="card-title">
                  {{'event.details.configureVivaWallet' | translate}}
                </h6>
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>{{'event.details.device' | translate}}</th>
                        <th>Client ID</th>
                        <th>Client Secret</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let deviceUser of event.deviceUsers">
                        <ng-container *ngIf="deviceUser.enableVivaWallet">
                          <td>{{deviceUser.name}}</td>
                          <td>
                              <input class="form-control form-control-sm" type="text" [attr.id]="'input-isv-client-id-' + deviceUser.id" value="{{deviceUser.isvClientId}}" placeholder="{{deviceUser.isvClientId}}" />
                          </td>
                          <td>
                              <input class="form-control form-control-sm" type="text" [attr.id]="'input-isv-client-secret-' + deviceUser.id" value="{{deviceUser.isvClientSecret}}" placeholder="{{deviceUser.isvClientSecret}}" />
                          </td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div *ngIf="event.hasSumUp && hasSumUpUsers()" style="width: 50%;">
                <h6 class="card-title">
                  {{'event.details.configureSumUp' | translate}}
                </h6>
                <div class="table-responsive" style="width:auto;">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th>{{'event.details.device' | translate}}</th>
                        <th>Affiliate Key</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let deviceUser of event.deviceUsers">
                        <ng-container *ngIf="deviceUser.enableSumUp">
                          <td>{{deviceUser.name}}</td>
                          <td>
                              <input class="form-control form-control-sm" type="text" [attr.id]="'input-affiliate-key-' + deviceUser.id" value="{{deviceUser.affiliateKey}}" placeholder="{{deviceUser.affiliateKey}}" />
                          </td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- #Fiscal Printer Field hidden currently#

            <div style="display: flex;">
              <div *ngIf="hasFiscalPrinters()">
                <h6 class="card-title">{{'event.details.configureFiscalPrinters' | translate}}</h6>
                <span class="pr-1" style="white-space: break-spaces">{{'event.details.configureFiscalPrinters_description' | translate}}</span>
                <div class="table-responsive">
                  <table class="table table-sm">
                    <thead>
                    <tr>
                      <th>{{'event.details.device' | translate}}</th>
                      <th>{{'event.details.ipAddress' | translate}} *</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let deviceUser of event.deviceUsers">
                      <ng-container *ngIf="deviceUser.hasFiscalPrinter">
                        <td>{{deviceUser.name}}</td>
                        <td><input
                            class="form-control form-control-sm"
                            type="text"
                            [attr.id]="'input-ip-address-' + deviceUser.id"
                            value="{{deviceUser.fiscalPrinterIP}}"
                            placeholder="{{deviceUser.fiscalPrinterIP}}"/>
                        </td>
                      </ng-container>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          -->
            <div style="float: right;">
              <button class="btn btn-primary" (click)="updateDevicesUser()">
                <i class="fa fa-save"></i>{{ 'event.details.update' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card" style="margin-top: 10px;" *ngIf='!eventWithoutPrinter'>
        <div class="card-header">
          {{'event.details.ownPrinterInformations' | translate}}
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-sm ">
                <thead>
                    <tr>
                        <th>{{'event.details.printerName' | translate}}</th>
                        <th>{{'event.details.printerType' | translate}}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let printer of event.printers " [className]="checkOwnPrinter(printer.id) ? 'own-printer' : 'rented-printer'">
                        <td>{{printer.name}}</td>
                        <td>{{printer.printerType.name}}</td>
                        <td class="text-right">
                            <button type="button" style="margin-right:-10px" class="btn btn-sm btn-primary" (click)="addRemovePrinterToCompanyClick(printer.id,'del')" *ngIf="checkOwnPrinter(printer.id)"><th>{{'event.details.printerRemoveBtn' | translate}}</th></button>
                            <span class="rented-label" *ngIf="!checkOwnPrinter(printer.id)">{{'event.details.rented' | translate}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="card" *ngIf='selectablePrinterCount > 0'>
                <div class="card-body" style="padding-bottom: 0px;">
                    <div class="form-row align-items-center">
                        <div class="col">
                          <select class="form-control" [(ngModel)]="selectedPrinter">
                            <option *ngFor="let option of printerListOptions" [ngValue]="option.value">{{option.label}}</option>
                          </select>
                        </div>
                        <div class="col">
                            <button type="button" class="btn btn-sm btn-default"
                            (click)="addRemovePrinterToCompanyClick(0,'add')"
                            ><th>{{'event.details.printerAssignBtn' | translate}}</th></button>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mt-3" *ngIf="event.routers.length > 0">
        <div class="card-header">
          {{'event.details.routerInformations' | translate}}
        </div>
        <div class="card-body ">
          <div class="table-respnsive ">
            <table class="table table-sm ">
              <thead>
                <tr>
                  <th>{{'event.details.routerName' | translate}}</th>
                  <!-- <th>{{'event.details.routerStatus' | translate}}</th>
                            <th>{{'event.details.routerType' | translate}}</th> -->
                  <th>{{'event.details.channel' | translate}}</th>
                  <th>{{'event.details.routerMasterType' | translate}}</th>
                  <th>{{'event.details.networkName' | translate}}</th>
                  <th>{{'event.details.networkPassword' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let router of routers">
                  <td>{{router.name}}</td>
                  <!-- <td>{{router.status}}</td>
                            <td>{{router.routerType.name}}</td> -->
                  <td>{{router.channel}}</td>
                  <td>{{(router.master === 0 ? 'event.details.mainRouter' : 'event.details.slaveRouter') | translate}}
                  </td>
                  <td>{{router.networkName}}</td>
                  <td>{{router.networkPassword}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
